import Link from '@eliadmin/core/src/components/link';
import type { PropsWithChildren } from 'react';

type ContactLinkProps = PropsWithChildren<{
  href: string;
  className?: string;
  target?: string;
  prefetch?: boolean;
  prefetchOnHover?: boolean;
}>;

export function ContactLink({ href, children, className, ...linkProps }: ContactLinkProps) {
  // An absent configured phone number must not open an empty telephone action.
  if (/^tel:\s*(?:undefined|null)?$/i.test(href)) {
    return <span data-ea-visual-tag="a" className={className}>{children}</span>;
  }
  return <Link href={href} className={className} {...linkProps}>{children}</Link>;
}
